<template>
  <div>
     <textarea v-model="thisq.qml" :rows="thisq.choices.height" :cols="thisq.choices.width" placeholder="Ditt svar..."></textarea>
	<p v-if="essayfeedback && (!showfasit)"><input type="button" value="Sjekk svar" style="background-color:#def0b9;border:0.5px solid green" v-on:click="reveal"></p>
     <p v-if="showfasit" style="padding:3px;background-color:#bde273" v-html="thisq.choices.feedback"></p>
   </div>
</template>

<script>
   import ajaxmixin from './ajaxmixin.vue'

   export default {

      name: 'essay',

      mixins: [ajaxmixin],

      props: {
        thisq: Object,
        enbloc: Boolean,
        essayfeedback: {type: Boolean, default: false}
      },
   
       data: function() {
         return {
            showfasit: false
         }
      },
   
      methods: {
         reveal: function() {
            if (this.essayfeedback) {
               this.showfasit = true;
   	 }
         }
      }
   }

</script>


